import { render } from "./KeyboardF4.vue?vue&type=template&id=14a6b8d1"
import script from "./KeyboardF4.vue?vue&type=script&lang=js"
export * from "./KeyboardF4.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardF4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14a6b8d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14a6b8d1', __exports__)) {
    api.reload('14a6b8d1', __exports__)
  }
  
  module.hot.accept("./KeyboardF4.vue?vue&type=template&id=14a6b8d1", () => {
    api.rerender('14a6b8d1', render)
  })

}


export default __exports__